import store from './store';

export default (axios) => {

  axios.interceptors.request.use(
    request => {
      const token = store.getters.getToken
      if (token) {
        request.headers['Authorization'] = `JWT ${token}`
      }
      return request
    },
    error => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    response => {
      // Return a successful response back to the calling service
      return response;
    },
    error => {
      // Return any error which is not due to authentication back to the calling service
      if (error.status !== 401 && error.status !== 403) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }

      // Logout user if token refresh didn't work or user is disabled
      if (error.config.url == '/api/api-token-refresh' || error.response.message == 'Account is disabled.') {

        store.commit('SET_TOKEN', null);

        return new Promise((resolve, reject) => {
          reject(error);
        });
      }

      return store.dispatch('refreshToken', { axios })
        .then((res) => {
          store.commit('SET_TOKEN', res)
        })

  });
}